module.exports = __webpack_public_path__ + "img/矩形 8@2x.138e7716.png";